import React, { useState } from "react";
// import mapImg from "../../media/masterplan-1/MASTERPLAN-NOMBRES.PNG"
import {Modal, ModalHeader, ModalBody } from 'reactstrap';
import BarrioPolo from "../media/masterplan-1/polo-full.png"
import BarrioLaguna from "../media/masterplan-1/laguna-full.png.webp"
import BarrioIsla from "../media/masterplan-1/isla_full.png"
import BarrioNorte from "../media/masterplan-1/norte-full.png"
import BarrioCasco from "../media/masterplan-1/casco-1.png"
import BarrioGolf from "../media/masterplan-1/golf-full.png"
import BarrioEstribo from "../media/masterplan-1/estribo-full.png"
import MasterPlan1 from "../media/masterplan-1/Masterplan1.png"

export const MapMasterplan1 = () => {

    const [hoveredArea, setHoveredArea] = useState(null);
    const [modal1, setModal1] = useState(false);
    const toggle1 = () => setModal1(!modal1);
    const [modal2, setModal2] = useState(false);
    const toggle2 = () => setModal2(!modal2);
    const [modal3, setModal3] = useState(false);
    const toggle3 = () => setModal3(!modal3);
    const [modal4, setModal4] = useState(false);
    const toggle4 = () => setModal4(!modal4);
    const [modal5, setModal5] = useState(false);
    const toggle5 = () => setModal5(!modal5);
    const [modal6, setModal6] = useState(false);
    const toggle6 = () => setModal6(!modal6);
    const [modal7, setModal7] = useState(false);
    const toggle7 = () => setModal7(!modal7);

    const handleMouseOver = (area) => {
      setHoveredArea(area);
    };
  
    const handleMouseOut = () => {
      setHoveredArea(null);
    };

    return(
        <>
        <div style={{position:"relative"}}>
            <img src= {MasterPlan1}
                 useMap="#image-map" 
                 alt="Descripción" 		
                 width="1122"
		         height="768"
                 data-image-title="MASTERPLAN" />

            <map name="image-map">
                <area
                shape="poly"
                coords="72,608,70,650,58,675,58,719,793,705,806,655,742,572,595,633,574,640,557,647,495,644,451,637,394,613,375,606"
                title="BARRIO POLO"
				alt="area1"
                onMouseOver={() => handleMouseOver('area1')}
                onMouseOut={handleMouseOut}
                onClick={toggle1}
            />
                <area
                shape="poly"
                coords="156,83,143,139,135,147,125,170,193,207,200,185,187,222,176,246,161,426,163,443,169,453,175,461,184,464,195,466,203,466,360,464,369,462,378,456,387,450,396,441,407,423,448,359,453,351,462,347,471,347,479,350,483,341,477,82"
				title="BARRIO ISLA"
				alt="area2"
                onMouseOver={() => handleMouseOver('area2')}
                onMouseOut={handleMouseOut}
                onClick={toggle2}
            />
                <area
                shape="poly"
                coords="122,175,193,211,175,248,173,265,166,330,162,385,159,431,162,446,168,455,176,464,187,469,200,469,362,467,381,462,396,449,421,411,445,373,456,358,467,352,477,355,490,365,374,547,353,580,354,588,366,598,74,603,82,563,77,533,86,483,86,443,98,223,107,211"
				title="BARRIO LAGUNA"
				alt="area3"
                onMouseOver={() => handleMouseOver('area3')}
                onMouseOut={handleMouseOut}
                onClick={toggle3}
            />
                <area
                shape="poly"
                coords="603,300,611,293,621,290,620,280,617,265,616,250,614,239,608,230,604,218,604,207,604,197,600,187,593,178,583,173,576,163,572,151,573,140,574,128,583,121,592,117,604,118,619,121,644,125,664,130,698,136,719,140,732,140,740,135,749,131,772,137,890,156,896,148,897,138,899,130,887,124,872,120,853,114,840,108,833,100,835,88,837,78,486,82,485,226,586,229,594,236,599,245,599,292"
				title="BARRIO CASCO"
				alt="area4"
                onMouseOver={() => handleMouseOver('area4')}
                onMouseOut={handleMouseOut}
                onClick={toggle4}
            />
                 <area
                shape="poly"
                coords="498,363,598,362,738,565,721,578,704,589,677,602,659,609,649,612,631,618,620,621,611,623,605,624,598,626,592,627,585,632,578,635,572,638,565,640,555,643,544,642,528,642,512,641,500,639,476,635,460,632,442,627,427,621,411,615,394,608,380,601,366,594,361,589,357,584,359,580,418,488"
				title="BARRIO ESTRIBO"
				alt="area5"
                onMouseOver={() => handleMouseOver('area5')}
                onMouseOut={handleMouseOut}
                onClick={toggle5}
            />
                <area
                shape="poly"
                coords="843,77,954,77,886,335,810,630,806,648,607,357,604,318,604,307,609,300,619,299,625,291,625,284,624,271,623,259,622,246,621,238,618,229,612,217,612,209,610,197,609,185,604,178,598,174,593,171,586,166,583,159,580,153,579,144,579,138,581,131,585,126,591,124,597,123,605,125,629,130,670,137,704,143,717,145,723,147,734,145,741,145,745,142,748,138,755,139,766,141,804,148,818,150,846,156,862,158,869,160,876,162,884,163,895,162,900,158,901,152,902,145,904,139,905,133,902,127,898,122,892,118,882,115,868,112,859,108,850,106,841,103,841,97,842,89"
				title="BARRIO GOLF"
				alt="area6"
                onMouseOver={() => handleMouseOver('area6')}
                onMouseOut={handleMouseOut}
                onClick={toggle6}
            />
                <area
                shape="poly"
                coords="985,263,1012,263,1012,214,1008,214,1008,76,961,76,908,289,898,324,896,332,904,338,905,360,906,513,909,670,908,665,909,691,910,701,1030,699,1026,498,1025,463,991,461,987,329"
				title="BARRIO NORTE"
				alt="area7"
                onMouseOver={() => handleMouseOver('area7')}
                onMouseOut={handleMouseOut}
                onClick={toggle7}
            />
            </map>
            {hoveredArea === 'area1' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: `polygon(
                            6.42% 79.17%, 6.24% 84.64%, 5.17% 87.89%, 5.17% 93.62%, 
                            70.71% 91.93%, 71.82% 85.28%, 66.14% 74.48%, 
                            53.04% 82.42%, 51.16% 83.33%, 49.64% 84.27%, 
                            44.11% 83.85%, 40.19% 82.99%, 35.11% 79.82%, 
                            33.40% 78.91%
                            )`,
                            pointerEvents: 'none', 
                        }}
                        />
                ) }
            {hoveredArea === 'area2' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(13.903743315508022% 10.807291666666668%, 12.745098039215685% 18.098958333333336%, 12.032085561497325% 19.140625%, 11.140819964349376% 22.135416666666664%, 17.20142602495544% 26.953125%, 17.825311942959% 24.088541666666664%, 16.666666666666664% 28.90625%, 15.686274509803921% 32.03125%, 14.349376114081997% 55.46875%, 14.527629233511586% 57.682291666666664%, 15.062388591800357% 58.984375%, 15.597147950089127% 60.026041666666664%, 16.39928698752228% 60.416666666666664%, 17.379679144385026% 60.677083333333336%, 18.092691622103388% 60.677083333333336%, 32.0855614973262% 60.416666666666664%, 32.887700534759354% 60.15625%, 33.68983957219251% 59.375%, 34.49197860962567% 58.59375%, 35.294117647058826% 57.421875%, 36.27450980392157% 55.078125%, 39.928698752228165% 46.74479166666667%, 40.37433155080214% 45.703125%, 41.17647058823529% 45.18229166666667%, 41.97860962566845% 45.18229166666667%, 42.69162210338681% 45.57291666666667%, 43.04812834224599% 44.40104166666667%, 42.513368983957214% 10.677083333333332%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}

            {hoveredArea === 'area3' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(10.87344028520499% 22.786458333333336%, 17.20142602495544% 27.473958333333332%, 15.597147950089127% 32.29166666666667%, 15.418894830659536% 34.50520833333333%, 14.795008912655971% 42.96875%, 14.43850267379679% 50.130208333333336%, 14.171122994652407% 56.119791666666664%, 14.43850267379679% 58.072916666666664%, 14.973262032085561% 59.244791666666664%, 15.686274509803921% 60.416666666666664%, 16.666666666666664% 61.067708333333336%, 17.825311942959% 61.067708333333336%, 32.263814616755795% 60.807291666666664%, 33.9572192513369% 60.15625%, 35.294117647058826% 58.463541666666664%, 37.5222816399287% 53.515625%, 39.66131907308378% 48.56770833333333%, 40.64171122994652% 46.61458333333333%, 41.622103386809265% 45.83333333333333%, 42.513368983957214% 46.22395833333333%, 43.672014260249554% 47.52604166666667%, 33.33333333333333% 71.22395833333334%, 31.46167557932264% 75.52083333333334%, 31.550802139037433% 76.5625%, 32.62032085561498% 77.86458333333334%, 6.59536541889483% 78.515625%, 7.308377896613191% 73.30729166666666%, 6.862745098039216% 69.40104166666666%, 7.66488413547237% 62.890625%, 7.66488413547237% 57.682291666666664%, 8.73440285204991% 29.036458333333332%, 9.536541889483066% 27.473958333333332%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}


         {hoveredArea === 'area4' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(53.7433155080214% 39.0625%, 54.45632798573975% 38.15104166666667%, 55.3475935828877% 37.76041666666667%, 55.258467023172905% 36.45833333333333%, 54.99108734402852% 34.50520833333333%, 54.90196078431373% 32.55208333333333%, 54.72370766488414% 31.119791666666668%, 54.188948306595364% 29.947916666666668%, 53.83244206773619% 28.385416666666668%, 53.83244206773619% 26.953125%, 53.83244206773619% 25.651041666666668%, 53.475935828877006% 24.348958333333336%, 52.85204991087345% 23.177083333333336%, 51.9607843137255% 22.526041666666664%, 51.33689839572193% 21.223958333333336%, 50.98039215686274% 19.661458333333336%, 51.06951871657755% 18.229166666666664%, 51.15864527629233% 16.666666666666664%, 51.9607843137255% 15.755208333333334%, 52.76292335115864% 15.234375%, 53.83244206773619% 15.364583333333334%, 55.169340463458106% 15.755208333333334%, 57.39750445632799% 16.276041666666664%, 59.180035650623886% 16.927083333333336%, 62.21033868092691% 17.708333333333336%, 64.08199643493762% 18.229166666666664%, 65.24064171122996% 18.229166666666664%, 65.9536541889483% 17.578125%, 66.75579322638147% 17.057291666666664%, 68.80570409982175% 17.838541666666664%, 79.32263814616756% 20.3125%, 79.85739750445633% 19.270833333333336%, 79.94652406417111% 17.96875%, 80.12477718360071% 16.927083333333336%, 79.05525846702317% 16.145833333333336%, 77.71836007130125% 15.625%, 76.02495543672015% 14.84375%, 74.8663101604278% 14.0625%, 74.24242424242425% 13.020833333333334%, 74.42067736185383% 11.458333333333332%, 74.59893048128342% 10.15625%, 43.31550802139038% 10.677083333333332%, 43.22638146167558% 29.427083333333332%, 52.22816399286988% 29.817708333333332%, 52.94117647058824% 30.729166666666668%, 53.38680926916221% 31.901041666666668%, 53.38680926916221% 38.02083333333333%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}  

        {hoveredArea === 'area5' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(44.38502673796791% 47.265625%, 53.297682709447415% 47.13541666666667%, 65.77540106951871% 73.56770833333334%, 64.26024955436719% 75.26041666666666%, 62.745098039215684% 76.69270833333334%, 60.33868092691622% 78.38541666666666%, 58.73440285204992% 79.296875%, 57.84313725490197% 79.6875%, 56.23885918003565% 80.46875%, 55.258467023172905% 80.859375%, 54.45632798573975% 81.11979166666666%, 53.92156862745098% 81.25%, 53.297682709447415% 81.51041666666666%, 52.76292335115864% 81.640625%, 52.139037433155075% 82.29166666666666%, 51.515151515151516% 82.68229166666666%, 50.98039215686274% 83.07291666666666%, 50.356506238859176% 83.33333333333334%, 49.465240641711226% 83.72395833333334%, 48.484848484848484% 83.59375%, 47.05882352941176% 83.59375%, 45.632798573975045% 83.46354166666666%, 44.563279857397504% 83.203125%, 42.42424242424242% 82.68229166666666%, 40.998217468805706% 82.29166666666666%, 39.39393939393939% 81.640625%, 38.05704099821747% 80.859375%, 36.63101604278075% 80.078125%, 35.115864527629235% 79.16666666666666%, 33.8680926916221% 78.25520833333334%, 32.62032085561498% 77.34375%, 32.174688057041% 76.69270833333334%, 31.818181818181817% 76.04166666666666%, 31.996434937611408% 75.52083333333334%, 37.254901960784316% 63.541666666666664%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}  

            {hoveredArea === 'area6' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(75.1336898395722% 10.026041666666668%, 85.02673796791443% 10.026041666666668%, 78.96613190730838% 43.61979166666667%, 72.19251336898395% 82.03125%, 71.83600713012478% 84.375%, 54.09982174688057% 46.484375%, 53.83244206773619% 41.40625%, 53.83244206773619% 39.97395833333333%, 54.278074866310156% 39.0625%, 55.169340463458106% 38.93229166666667%, 55.70409982174688% 37.890625%, 55.70409982174688% 36.97916666666667%, 55.61497326203209% 35.28645833333333%, 55.525846702317295% 33.72395833333333%, 55.43672014260249% 32.03125%, 55.3475935828877% 30.989583333333332%, 55.080213903743314% 29.817708333333332%, 54.54545454545454% 28.255208333333332%, 54.54545454545454% 27.213541666666668%, 54.367201426024955% 25.651041666666668%, 54.278074866310156% 24.088541666666664%, 53.83244206773619% 23.177083333333336%, 53.297682709447415% 22.65625%, 52.85204991087345% 22.265625%, 52.22816399286988% 21.614583333333336%, 51.9607843137255% 20.703125%, 51.69340463458111% 19.921875%, 51.60427807486631% 18.75%, 51.60427807486631% 17.96875%, 51.7825311942959% 17.057291666666664%, 52.139037433155075% 16.40625%, 52.67379679144385% 16.145833333333336%, 53.20855614973262% 16.015625%, 53.92156862745098% 16.276041666666664%, 56.060606060606055% 16.927083333333336%, 59.71479500891266% 17.838541666666664%, 62.745098039215684% 18.619791666666664%, 63.903743315508024% 18.880208333333336%, 64.43850267379679% 19.140625%, 65.41889483065954% 18.880208333333336%, 66.0427807486631% 18.880208333333336%, 66.39928698752227% 18.489583333333336%, 66.66666666666666% 17.96875%, 67.29055258467022% 18.098958333333336%, 68.27094474153299% 18.359375%, 71.65775401069519% 19.270833333333336%, 72.90552584670232% 19.53125%, 75.40106951871658% 20.3125%, 76.8270944741533% 20.572916666666664%, 77.45098039215686% 20.833333333333336%, 78.07486631016043% 21.09375%, 78.78787878787878% 21.223958333333336%, 79.76827094474153% 21.09375%, 80.21390374331551% 20.572916666666664%, 80.3030303030303% 19.791666666666664%, 80.3921568627451% 18.880208333333336%, 80.57040998217468% 18.098958333333336%, 80.65953654188948% 17.317708333333336%, 80.3921568627451% 16.536458333333336%, 80.03565062388593% 15.885416666666666%, 79.50089126559715% 15.364583333333334%, 78.6096256684492% 14.973958333333334%, 77.36185383244207% 14.583333333333334%, 76.55971479500892% 14.0625%, 75.75757575757575% 13.802083333333334%, 74.9554367201426% 13.411458333333334%, 74.9554367201426% 12.630208333333334%, 75.0445632798574% 11.588541666666668%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}  
            {hoveredArea === 'area7' && (
                        <div
                        style={{
                            position: 'absolute',
                            top: '0px', 
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            clipPath: 'polygon(87.78966131907309% 34.24479166666667%, 90.19607843137256% 34.24479166666667%, 90.19607843137256% 27.864583333333332%, 89.83957219251337% 27.864583333333332%, 89.83957219251337% 9.895833333333332%, 85.650623885918% 9.895833333333332%, 80.92691622103388% 37.63020833333333%, 80.03565062388593% 42.1875%, 79.85739750445633% 43.22916666666667%, 80.57040998217468% 44.01041666666667%, 80.65953654188948% 46.875%, 80.74866310160428% 66.796875%, 81.01604278074866% 87.23958333333334%, 80.92691622103388% 86.58854166666666%, 81.01604278074866% 89.97395833333334%, 81.10516934046346% 91.27604166666666%, 91.80035650623886% 91.015625%, 91.44385026737967% 64.84375%, 91.35472370766489% 60.286458333333336%, 88.32442067736186% 60.026041666666664%, 87.96791443850267% 42.83854166666667%)',
                            pointerEvents: 'none', 
                        }}
                        />
                    )}  

         </div>

        <div>
            <Modal isOpen={modal1} toggle={toggle1} size="lg">
            <ModalHeader toggle={toggle1}>BARRIO POLO</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"90%"}} src={BarrioPolo}></img>
                    </div>
                    <p>Contará con una cancha de polo familiar, studs para guardar caballos y una huerta bio-dinámica con una compostera gigante para que la gente que dese, pueda trabajar en la misma. Ademas de un bosque, parque en común. En septiembre 2022 comenzaron las primeras construcciones.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal2} toggle={toggle2} size="lg">
            <ModalHeader toggle={toggle2}>BARRIO ISLA</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"35%"}} src={BarrioIsla}></img>
                    </div>
                    <p>El último barrio a entregar con una laguna de 50 hectáreas de entre 8/10 metros donde los terrenos dan al agua. Cada uno va a poder hace su propia playita o muelle. Destinada a deportes que no tengan motor, se podrá nadar y se sembraran peces para que pueda pescar. Es una laguna artificial que se llena de manera natural con agua de napa.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal3} toggle={toggle3} size="lg">
            <ModalHeader toggle={toggle3}>BARRIO LAGUNA</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"45%"}} src={BarrioLaguna}></img>
                    </div>
                    <p>Es el barrio mas cercano a la Isla, ya comenzaron las primeras construcciones.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal4} toggle={toggle4} size="lg">
            <ModalHeader toggle={toggle4}>BARRIO CASCO</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"85%"}} src={BarrioCasco}></img>
                    </div>
                    <p>Es un barrio que al haberse reducido, quedo mas tranquilo, esta cercano a la Isla y al Area de Golf.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal5} toggle={toggle5} size="lg">
            <ModalHeader toggle={toggle5}>BARRIO ESTRIBO</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"60%"}} src={BarrioEstribo}></img>
                    </div>
                    <p>Se entregó en abril de 2021, ya hay gente viviendo y hay 32 casas que se entregan en diciembre. Es el barrio mas avanzado con una ubicación central en el desarrollo.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal6} toggle={toggle6} size="lg">
            <ModalHeader toggle={toggle6}>BARRIO GOLF</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{width:"30%"}} src={BarrioGolf}></img>
                    </div>
                    <p>Tendrá nueve hoyos para la practica de golf y será entregado a fin del 2024, antes de esto vamos a hacer un driving en la parte norte del lugar con una confitería.</p>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <Modal isOpen={modal7} toggle={toggle7} size="lg">
            <ModalHeader toggle={toggle7}>BARRIO NORTE</ModalHeader>
            <ModalBody>
                    <div style={{ padding:"30px", display:"flex", justifyContent:"center"}}>
                    <img style={{height:"350px"}} src={BarrioNorte}></img>
                    </div>
                    <p>Próximo al colegio y al área deportiva. Ya comenzaron las primeras construcciones.</p>
            </ModalBody>
            </Modal>
        </div>

        </>
    )
}


export default MapMasterplan1;